(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["click-video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  var wrapper = event.target.closest('.click-video__wrapper');
  if (!wrapper || wrapper.dataset.playing === 'true') return;
  wrapper.dataset.playing = 'true';

  var videoUrl = wrapper.getAttribute('data-video-url');
  if (!videoUrl) return;

  if (videoUrl.match(/\.(mp4|webm|ogg)$/i) !== null || videoUrl.includes('cloudfront.net') || !wrapper.hasAttribute('data-video-type')) {
    var video = document.createElement('video');
    video.src = videoUrl;
    video.autoplay = true;
    video.loop = true;
    video.muted = true;
    video.controls = true;
    video.style.width = '100%';
    video.style.height = '100%';
    video.style.objectFit = 'cover';
    wrapper.innerHTML = '';
    wrapper.appendChild(video);
    return;
  }

  var type = wrapper.getAttribute('data-video-type');
  var id   = wrapper.getAttribute('data-video-id');
  if (!type || !id) return;

  var src;
  if (type === 'youtube') {
    src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0&mute=1';
  } else if (type === 'vimeo') {
    src = 'https://player.vimeo.com/video/' + id + '?autoplay=1&muted=1';
  } else { return; }

  var iframe = document.createElement('iframe');
  iframe.allowFullscreen = true;
  iframe.allow = 'autoplay; encrypted-media';
  iframe.frameBorder = 0;
  iframe.src = src;
  iframe.style.width = '100%';
  iframe.style.height = '100%';
  wrapper.innerHTML = '';
  wrapper.appendChild(iframe);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-bar"] && !Shopify.designMode) return;
  try {
    
function initCountdowns(root) {
  var scope = root || document;
  var timers = scope.querySelectorAll('.countdown-bar__timer:not([data-bound])');

  timers.forEach(function (timer) {
    timer.dataset.bound = 'true';

    var endDateStr = timer.getAttribute('data-end-date');
    if (!endDateStr) return;

    // Expecting YYYY-MM-DDTHH:MM:SS
    var parts = endDateStr.split(/[-T:]/);
    if (parts.length < 3) return;

    var target = new Date(
      parseInt(parts[0], 10),
      parseInt(parts[1], 10) - 1,
      parseInt(parts[2], 10),
      parseInt(parts[3] || 0, 10),
      parseInt(parts[4] || 0, 10),
      parseInt(parts[5] || 0, 10)
    );
    if (isNaN(target.getTime())) return;

    var daysEl    = timer.querySelector('.js-countdown-days');
    var hoursEl   = timer.querySelector('.js-countdown-hours');
    var minutesEl = timer.querySelector('.js-countdown-minutes');

    if (!daysEl || !hoursEl || !minutesEl) return;

    function pad(n){ return n < 10 ? '0' + n : '' + n; }

    var intervalId;

    function tick() {
      var now  = new Date();
      var diff = target.getTime() - now.getTime();

      if (diff <= 0) {
        daysEl.textContent =
        hoursEl.textContent =
        minutesEl.textContent = '00';
        clearInterval(intervalId);
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days    = Math.floor(totalSeconds / 86400);
      var hours   = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);

      daysEl.textContent    = pad(days);
      hoursEl.textContent   = pad(hours);
      minutesEl.textContent = pad(minutes);
    }

    tick();                      // initial paint
    intervalId = setInterval(tick, 1000); // update every second
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initCountdowns();
});

document.addEventListener('shopify:section:load', function (event) {
  initCountdowns(event.target);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
